module.exports = __webpack_public_path__ + "static/img/2.0633281.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.jpeg
// module id = hy6w
// module chunks = 0